import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebase";

/**
 * Lê todos os documentos da coleção "taxa" e devolve um array
 */
export async function FGetBankTouaki() {
  const ref = collection(db, "taxa"); // coleção raiz "taxa"
  const snap = await getDocs(ref);

  const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));

  if (list.length === 0) {
    throw new Error("Não foram encontrados documentos em 'taxa'.");
  }

  return list; // retorna array
}

export default FGetBankTouaki;